// Shortens text for meta descriptions without cutting a word in half. Collapses whitespace first,
// since descriptions are often scraped from HTML. The ellipsis counts towards `max`.
const truncateAtWord = (text, max = 155) => {
  const clean = (text || "").replace(/\s+/g, " ").trim();
  if (clean.length <= max) return clean;

  const cut = clean.slice(0, max - 1);
  const lastSpace = cut.lastIndexOf(" ");
  // A single word longer than the limit has no boundary to fall back to; cut it hard.
  const trimmed = lastSpace > 0 ? cut.slice(0, lastSpace) : cut;
  return `${trimmed.replace(/[\s,.;:!?—–-]+$/, "")}…`;
};

export default truncateAtWord;
